import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const productsJcsFormFieldsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-products-jcs-form-fields" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
